import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import dayjs from "dayjs";
import {FormControl, FormGroup} from "@angular/forms";
import {SeasonFullModel} from "../../../models/season-models/season-full-model";
import {SeasonDropdownModel} from "../../../models/season-models/season-dropdown-model";
import {SeasonDetailFieldModel} from "../../../models/season-models/season-detail-field-model";
import {Router} from "@angular/router";
import {
    LinkFieldToSeasonComponent
} from "../../../dialogs/season-manager-dialogs/link-field-to-season/link-field-to-season.component";
import {MatDialog} from "@angular/material/dialog";
import {catchError, throwError} from "rxjs";
import {NavBarComponent} from "../../../nav-bar/nav-bar.component";
import {SeasonManagerService} from "../../../services/season-manager.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
    CreateEditSeasonComponent
} from "../../../dialogs/season-manager-dialogs/create-edit-season/create-edit-season.component";

@Component({
    selector: 'app-season-field-details',
    templateUrl: './season-field-details.component.html',
    styleUrls: ['./season-field-details.component.css'],
    standalone: false
})
export class SeasonFieldDetailsComponent implements OnInit {

    protected readonly dayjs = dayjs;
    dateStringFormatting = 'YYYY-MM-DD';
    @Input() fieldId: number = 0;
    @Input() fieldAdminStyle: any = null;
    @Input() hideSeasonDetails: boolean = false;
    isInAnotherActiveSeason: boolean = false;
    isControlDisabled: boolean = false;
    panelOpenState: boolean = false;
    linkFieldForm: FormGroup = new FormGroup({
        season: new FormControl(null),
    });
    placeholder: string = '-';
    selectedSeason: SeasonDropdownModel = null;
    @Input() seasons: SeasonDropdownModel[] = [];
    @Output() emitNewSeason = new EventEmitter();
    @Output() emitDataRefresh = new EventEmitter();
    @Output() emitCloseDialog = new EventEmitter();
    @Input() seasonFormData: SeasonDetailFieldModel = null;

    constructor(
        private router: Router,
        public matDialog: MatDialog,
        private nav: NavBarComponent,
        private snackBar: MatSnackBar,
        private seasonManagerService: SeasonManagerService
    ) {
    }

    ngOnInit() {
        this.validateLinkFormControls();
        // console.log(this.seasonFormData);
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 5000,
        });
    }

    setSelectedSeason(season) {
        this.selectedSeason = season;
    }

    manageSeason() {
        this.emitCloseDialog.emit();
        this.router.navigate([`season/${this.seasonFormData.season.id}/season-admin`], { queryParams: { from: this.router.url } });
    }

    openLinkSeasonDialog() {
        if(!this.selectedSeason) {
            this.openSnackBar('Please Select a Season', 'DISMISS');
        } else {
            const dialogRef = this.matDialog.open(LinkFieldToSeasonComponent, {
                data: {

                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result.option == 'link') {
                    this.linkFieldToSeason();
                }
            });
        }
    }

    openCreateNewSeasonDialog() {

        const dialogRef = this.matDialog.open(CreateEditSeasonComponent, {

            data: {
                isEditMode: false,
            }
        });

        dialogRef.afterClosed().subscribe(result => {

            setTimeout(() => {
                this.emitNewSeason.emit();
            }, 1400)

        });
    }

    linkFieldToSeason() {
        this.nav.toggleLoading(true);
        if (this.selectedSeason !== null) {
            this.seasonManagerService.postNewSeasonDetails(Number(this.fieldId), this.selectedSeason.id).pipe(
                catchError(error => {
                    console.error();
                    this.nav.toggleLoading(false);
                    return throwError(() => error);
                })
            ).subscribe((response) => {
                this.emitDataRefresh.emit();
                this.validateLinkFormControls();
                this.nav.toggleLoading(false);
            });
        } else {
            this.openSnackBar('Please Select a Season', 'DISMISS');
        }

    }

    refreshBrowser() {
        // FORCE REFRESH BROWSER
        this.router.navigateByUrl("/season-manager/fields", { skipLocationChange: true }).then(() => {
            this.router.navigate([`/season-manager/edit-link-field/${this.fieldId}`]);
        });
    }

    validateLinkFormControls() {

        if (this.seasonFormData) {
            if (this.seasonFormData.field.isInAnotherActiveSeason) {
                this.isControlDisabled = true; //link btn
                this.linkFieldForm.get('season').disable();
            } else {
                this.isControlDisabled = false; //link btn
                this.linkFieldForm.get('season').enable();
            }
        }

        if (this.seasonFormData.season) {
            let currentSeason = this.seasons.find(s => s.id === this.seasonFormData.season.id);
            if(currentSeason) {
                this.linkFieldForm.controls.season.setValue(currentSeason);
                this.selectedSeason = currentSeason;

            }
        }
    }
}
